module.exports = __webpack_public_path__ + "img/level_04.88ccd7cc.svg";